import React, { useEffect } from 'react'
// import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { LinkContainer } from 'react-router-bootstrap'
import { Container, Nav, Navbar, NavDropdown } from 'react-bootstrap'
import { getUserDetails, logout } from '../actions/userActions'
import { getSettings } from '../actions/settingActions'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCashRegister } from '@fortawesome/free-solid-svg-icons' // Example icon

const Header = () => {
  // const navigate = useNavigate()
  const dispatch = useDispatch()

  const userLogin = useSelector((state) => state.userLogin)
  const { userInfo } = userLogin

  const userDetails = useSelector((state) => state.userDetails)
  const { user } = userDetails

  const settingList = useSelector((state) => state.settingList)
  const { settings, success } = settingList

  const logoutHandler = () => {
    const id = userInfo._id
    localStorage.removeItem('userInfo')
    localStorage.removeItem('qrcodeScan')
    dispatch(logout(id))
  }

  useEffect(() => {
    if (userInfo && !success) {
      dispatch(getSettings())
    } else if (userInfo && success) {
      dispatch(getUserDetails(userInfo._id))
    }
  }, [userInfo, success, dispatch])

  return (
    <header>
      <Navbar className='bg-primary' expand='lg' collapseOnSelect>
        <Container>
          {!userInfo ? (
            <Nav.Link href='/'>
              <Navbar.Brand>
                <FontAwesomeIcon icon={faCashRegister} /> Geranium PoS
              </Navbar.Brand>
            </Nav.Link>
          ) : (
            <Navbar.Brand>
              {settings.taxrate !== undefined && (
                <span>
                  <FontAwesomeIcon icon={faCashRegister} />{' '}
                  {` Tax ${settings.taxrate}% `}
                </span>
              )}
              {settings.currency} User:{' '}
              {!userInfo.isMaster || userInfo.isAdmin
                ? userInfo.name
                : user.name}
              {userInfo && userInfo.isAdmin && userInfo.isMaster && (
                <span className='text-danger'> (Master)</span>
              )}
            </Navbar.Brand>
          )}

          <Navbar.Toggle aria-controls='basic-navbar-nav' />
          <Navbar.Collapse id='basic-navbar-nav'>
            <Nav className='ms-auto'>
              {userInfo && (
                <>
                  <NavDropdown title='Sales' className='text-primary'>
                    <LinkContainer to='/pos'>
                      <NavDropdown.Item>Sales Terminal</NavDropdown.Item>
                    </LinkContainer>
                    <LinkContainer to='/returns'>
                      <NavDropdown.Item>Sales Return</NavDropdown.Item>
                    </LinkContainer>
                  </NavDropdown>

                  <NavDropdown title='Inventory' className='text-primary'>
                    <LinkContainer to='/inventory'>
                      <NavDropdown.Item>List Inventory</NavDropdown.Item>
                    </LinkContainer>

                    {userInfo && userInfo.isAdmin && (
                      <>
                        <LinkContainer to='/inventory/add'>
                          <NavDropdown.Item>Add Entry</NavDropdown.Item>
                        </LinkContainer>
                      </>
                    )}

                    <LinkContainer to='/items'>
                      <NavDropdown.Item>List Items</NavDropdown.Item>
                    </LinkContainer>

                    <LinkContainer to='/name'>
                      <NavDropdown.Item>List Manufacturers</NavDropdown.Item>
                    </LinkContainer>
                  </NavDropdown>
                  {userInfo && userInfo.isAdmin && (
                    <NavDropdown title='Admin'>
                      <LinkContainer to='/admin/userlist'>
                        <NavDropdown.Item>Users</NavDropdown.Item>
                      </LinkContainer>
                    </NavDropdown>
                  )}
                  <NavDropdown title='Menu'>
                    {userInfo && userInfo.isAdmin && (
                      <LinkContainer to='/dashboard'>
                        <NavDropdown.Item>Dashboard</NavDropdown.Item>
                      </LinkContainer>
                    )}
                    <LinkContainer to='/reports'>
                      <NavDropdown.Item>Reports</NavDropdown.Item>
                    </LinkContainer>
                    {userInfo && userInfo.isAdmin && (
                      <>
                        <LinkContainer to='/settings'>
                          <NavDropdown.Item>Settings</NavDropdown.Item>
                        </LinkContainer>
                      </>
                    )}
                    {userInfo && (
                      <LinkContainer to='/profile'>
                        <NavDropdown.Item>Profile</NavDropdown.Item>
                      </LinkContainer>
                    )}
                    <NavDropdown.Item
                      as='a'
                      href='mailto:info@hermanosgazpachos.ca'
                    >
                      Contact Us
                    </NavDropdown.Item>
                    <NavDropdown.Divider />
                    <NavDropdown.Item onClick={logoutHandler}>
                      Logout
                    </NavDropdown.Item>
                  </NavDropdown>
                </>
              )}
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </header>
  )
}

export default Header
